// utils/getYAxisConfig.ts
export function getYAxisConfig(chartData: any[]) {
  const yValues = chartData
    .map((item: any) => item?.y)
    .filter((value: any) => typeof value === "number" && !isNaN(value));
  if (!yValues.length) {
    return {
      domain: [0, 1] as [number, number],
      ticks: [0, 1],
    };
  }
  let min = Math.min(...yValues);
  let max = Math.max(...yValues);
  if (min === max) {
    const pad = min === 0 ? 1 : Math.abs(min) * 0.1;
    min -= pad;
    max += pad;
  }
  const range = max - min;
  const roughStep = range / 5;
  const safeStep = roughStep > 0 ? roughStep : 1;
  const magnitude = Math.pow(10, Math.floor(Math.log10(safeStep)));
  const normalized = safeStep / magnitude;
  let niceNormalized = 10;
  if (normalized <= 1) niceNormalized = 1;
  else if (normalized <= 2) niceNormalized = 2;
  else if (normalized <= 5) niceNormalized = 5;
  const step = niceNormalized * magnitude;
  const domainMin = Math.floor(min / step) * step;
  const domainMax = Math.ceil(max / step) * step;
  const ticks: number[] = [];
  for (let tick = domainMin; tick <= domainMax + step / 2; tick += step) {
    ticks.push(Number(tick.toFixed(6)));
  }
  return {
    domain: [domainMin, domainMax] as [number, number],
    ticks,
  };
}
